var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.status.class,attrs:{"title":_vm.status.msg},on:{"click":function($event){_vm.alert(this.getAttribute('title'))}}})}
var staticRenderFns = []

export { render, staticRenderFns }